export enum GroupEmployeeStatus {
Active,
InActive,
}
